import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };


@Injectable()
export class TopicCardService {
  //baseUrl: String = 'http://localhost:60664/';

  constructor(private _http: HttpClient) {
  }


  getCircularReplacer = () => {
    const seen = new WeakSet();
    return (key, value) => {
      if (typeof value === "object" && value !== null) {
        if (seen.has(value)) {
          return;
        }
        seen.add(value);
      }
      return value;
    };
  };


  uploadNewTopicCard(documentDetails): any {
    return this._http.post(environment.APIEndpoint + 'api/TopicCard/uploadNewTopicCard', documentDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

    

  getTopicCardVersionHistoryList(docid:number): any {
    return this._http.get(environment.APIEndpoint +'api/TopicCard/getTopicCardVersionHistoryList?docId=' + docid)
      .map((res) => res)
      .catch(this._errorHandler);
  }
  
  getTopicCardType(): any {

    return this._http.get(environment.APIEndpoint + 'api/TopicCard/GetTopicCardType')
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  getTopicCardCategory(): any {
    return this._http.get(environment.APIEndpoint + 'api/TopicCard/getTopicCardCategory')
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  getDocStatus(): any {

    return this._http.get(environment.APIEndpoint + 'api/ManageDoc/GetDocumentStatus')
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  deleteDocVersion(documentDetails): any {

    return this._http.post(environment.APIEndpoint + 'api/TopicCard/DeleteTopicCardVersion', documentDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  unapproveDocument(documentDetails): any {

    return this._http.post(environment.APIEndpoint + 'api/TopicCard/UnauthorizeTopicCard', documentDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  getEngagementTopicCard(documentDetails): any {

    return this._http.post(environment.APIEndpoint + 'api/TopicCard/GetEngagementTopicCard', documentDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  } 

  getEngagementTopicCardsBasedOnLanguage(documentDetails): any {
    return this._http.post(environment.APIEndpoint + 'api/TopicCard/getEngagementTopicCardsBasedOnLanguage', documentDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  } 

  getEngagementTopicCards(documentDetails): Promise<any>{
    return this._http.post(environment.APIEndpoint + 'api/TopicCard/GetEngagementTopicCard',documentDetails)
    .toPromise()
     .then(res => res)
     .catch(this._errorHandler);
  }

  getEngagementTopicCardswithImages(documentDetails,languageId): Promise<any>{
    return this._http.post(environment.APIEndpoint + 'api/TopicCard/GetEngagementTopicCardsWithImages?languageId='+languageId,documentDetails)
    .toPromise()
     .then(res => res)
     .catch(this._errorHandler);
  }

  getTopicCards(engagementId:number): Promise<any>{
    return this._http.get(environment.APIEndpoint + 'api/TopicCard/GetTopicCards?engagementId='+engagementId)
    .toPromise()
     .then(res => res)
     .catch(this._errorHandler);
  }
  getDocVersionByDocId(documentDetails): any {

    return this._http.post(environment.APIEndpoint + 'api/TopicCard/GetTopicCardVersionByTopicCardId', documentDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  }

  saveTopicCardVersion(documentDetails): any {

    return this._http.post(environment.APIEndpoint + 'api/TopicCard/SaveTopicCardVersion', documentDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  } 

  approveDocumentVersion(documentDetails): any {

    return this._http.post(environment.APIEndpoint + 'api/TopicCard/ApproveTopicCardVersion', documentDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  } 

  sendTopicCardApprovalMail(documentDetails): any {

    return this._http.post(environment.APIEndpoint + 'api/TopicCard/SendTopicCardApprovalMail', documentDetails)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  } 

  getApproverList(engagementId): any {

    return this._http.get(environment.APIEndpoint + 'api/ManageDoc/GetApproverList?engagementId='+engagementId)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  } 

  getTopicCardApprovalList(showAll : boolean): any {

    return this._http.get(environment.APIEndpoint + 'api/TopicCard/GetTopicCardListForApproval?showAll=' + showAll)
      .map((res: Response) => res)
      .catch(this._errorHandler);
  } 

  _errorHandler(error: Response) {
    return Observable.throw(error || 'Server Error');
  }
}
